import { render, staticRenderFns } from "./SubjectConsist.vue?vue&type=template&id=073fb84a&"
import script from "./SubjectConsist.vue?vue&type=script&lang=js&"
export * from "./SubjectConsist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports